import { render, staticRenderFns } from "./clazz_card.vue?vue&type=template&id=456f4a96&"
import script from "./clazz_card.vue?vue&type=script&lang=js&"
export * from "./clazz_card.vue?vue&type=script&lang=js&"
import style0 from "./clazz_card.vue?vue&type=style&index=0&id=456f4a96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports